/* eslint-disable no-case-declarations */
import {
  NOTICE_BOARD_UPDATE_LOGIN_TIME,
  NOTICE_BOARD_UPDATE_REMIND_LATER,
  NOTICE_BOARD_UPDATE_DO_NOT_SHOW,
  NOTICE_BOARD_UPDATE_NOTICE_VERSION,
} from '../../constants/ActionTypes';
import storage from '../../storage';
import { updateNotice } from './updaters';

const loginTime = storage.getItem('notice-board-login-time') || '';

const notices = storage.getItem('notice-board-notices') || [];

const noticeboard = (
  state = {
    loginTime,
    notices,
  },
  action
) => {
  switch (action.type) {
    case NOTICE_BOARD_UPDATE_LOGIN_TIME:
      const newLoginTime = new Date();

      storage.setItems({
        'notice-board-login-time': newLoginTime,
      });

      return { ...state, loginTime: newLoginTime };
    case NOTICE_BOARD_UPDATE_REMIND_LATER:
      const noticesRemindLater = updateNotice(state.notices, action.noticeId, {
        remindLater: new Date(),
      });

      storage.setItems({
        'notice-board-notices': noticesRemindLater,
      });

      return {
        ...state,
        notices: [...noticesRemindLater],
      };
    case NOTICE_BOARD_UPDATE_DO_NOT_SHOW:
      const noticesDoNotShow = updateNotice(state.notices, action.noticeId, {
        doNotShow: true,
      });

      storage.setItems({
        'notice-board-notices': noticesDoNotShow,
      });

      return {
        ...state,
        notices: [...noticesDoNotShow],
      };
    case NOTICE_BOARD_UPDATE_NOTICE_VERSION:
      const noticesVersion = updateNotice(state.notices, action.noticeId, {
        noticeVersion: action.data,
      });

      storage.setItems({
        'notice-board-notices': noticesVersion,
      });

      return {
        ...state,
        notices: [...noticesVersion],
      };
    default:
      return state;
  }
};

export default noticeboard;
